import React from "react";
import { Link } from "react-router-dom";
import LoginForm from "./LoginForm";
import Payment from "../../assets/assets/payment.svg";
import Logo from "../../assets/assets/Nibss-Logo.png";

const Login = () => {
  return (
    <div className="login-page">
      <Link to="/">
        <div className="login-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="login-wrap">
        <div className="bg-image">
          <img src={Payment} alt="payment" />
        </div>
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
